import { render, staticRenderFns } from "./DispatcherTerminalCard.vue?vue&type=template&id=2243be1c&scoped=true&"
import script from "./DispatcherTerminalCard.vue?vue&type=script&lang=js&"
export * from "./DispatcherTerminalCard.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherTerminalCard.vue?vue&type=style&index=0&id=2243be1c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243be1c",
  null
  
)

export default component.exports